import React from 'react'
import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'
import { MediaQuery } from 'stylist'
import withSession from 'components/withSession'
import withCurrentUser from 'components/withCurrentUser'
import { compose } from 'recompose'

const Menu = ({ session, currentUser }) => (
  <MediaQuery below="md">
    {matches =>
      matches ? (
        <MobileMenu isAuthenticated={session.isAuthenticated} />
      ) : (
        <DesktopMenu
          isAuthenticated={session.isAuthenticated}
          currentUser={currentUser}
        />
      )
    }
  </MediaQuery>
)

export default compose(
  withSession,
  withCurrentUser
)(Menu)



// WEBPACK FOOTER //
// ./src/routes/components/Menu.js